//* This function is used to ensure that the URL is https
export default function ensureHttps(url: string): string {
  // Trim leading/trailing spaces
  url = url.trim();

  // Check if the URL starts with 'http://' or 'https://'
  const regex = /^(https?:\/\/)/i;

  // If the URL starts with 'http://', replace it with 'https://'
  if (url.startsWith('http://')) {
    return 'https://' + url.slice(7);
  }

  // If the URL starts with 'https://', return it as is
  if (url.startsWith('https://')) {
    return url;
  }

  // If the URL has no scheme but starts with 'www.', add 'https://'
  if (url.startsWith('www.')) {
    return 'https://' + url;
  }

  // Handle cases like 'https:www.example.com' where there's a typo
  if (url.includes('https:') && !url.includes('https://')) {
    // Replace the first colon after 'https' with a slash
    url = url.replace('https:', 'https://');
  }

  // Otherwise, assume the user provided a domain and prepend 'https://'
  return 'https://' + url;
}
